var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_58067",
    "data-name": "Path 58067",
    d: "M277.7,211.479h-9.789a.783.783,0,0,0-.783.783v3.127a.783.783,0,0,0,.783.783h5.513a7.359,7.359,0,0,1-3.168,3.712l2.351,4.069a11.766,11.766,0,0,0,6-10.29,7.932,7.932,0,0,0-.135-1.537A.786.786,0,0,0,277.7,211.479Z",
    transform: "translate(-254.609 -201.566)",
    fill: "#167ee6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58068",
    "data-name": "Path 58068",
    d: "M44.8,337.5a7.3,7.3,0,0,1-6.318-3.655l-4.069,2.345a11.99,11.99,0,0,0,16.387,4.4v-.006l-2.351-4.069A7.25,7.25,0,0,1,44.8,337.5Z",
    transform: "translate(-32.798 -318.198)",
    fill: "#12b347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58069",
    "data-name": "Path 58069",
    d: "M262,394.854v-.006l-2.351-4.069a7.25,7.25,0,0,1-3.649.987v4.7A11.979,11.979,0,0,0,262,394.854Z",
    transform: "translate(-244 -372.461)",
    fill: "#0f993e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58070",
    "data-name": "Path 58070",
    d: "M4.7,134.113a7.25,7.25,0,0,1,.986-3.649l-4.069-2.345a11.945,11.945,0,0,0,0,11.989l4.069-2.345A7.25,7.25,0,0,1,4.7,134.113Z",
    transform: "translate(0 -122.113)",
    fill: "#ffd500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58071",
    "data-name": "Path 58071",
    d: "M44.8,4.7a7.271,7.271,0,0,1,4.637,1.665.78.78,0,0,0,1.049-.047L52.7,4.1a.789.789,0,0,0-.045-1.153A11.974,11.974,0,0,0,34.411,6.006L38.48,8.351A7.3,7.3,0,0,1,44.8,4.7Z",
    transform: "translate(-32.798)",
    fill: "#ff4b26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58072",
    "data-name": "Path 58072",
    d: "M260.637,6.361a.78.78,0,0,0,1.049-.047L263.9,4.1a.789.789,0,0,0-.045-1.153A11.964,11.964,0,0,0,256,0V4.7A7.271,7.271,0,0,1,260.637,6.361Z",
    transform: "translate(-244)",
    fill: "#d93f21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3822e5e8a94cec3cf2d3117eadd09c18.svg";
export { ForwardRef as ReactComponent };